// src/hooks/useIdiomas.ts
import { useQuery } from "@tanstack/react-query";
import api from "../api/axios";
export interface Idioma {
  id: number;
  nombre: string;
}
export function useIdiomas() {
  const { data = [], isFetching: loading } = useQuery({
    queryKey: ["idiomas"],
    queryFn: async () => (await api.get("/idiomas")).data,
  });
  return { rows: data, loading };
}
